// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

import { ICONVERSION as ICONVERSION_MERCEDES } from '../../../enums/Icons.mercedes'
import { ICONVERSION as ICONVERSION_DAIMLER } from '../../../enums/Icons.daimler'

@Component({
    name: 'Icon',
    mixins: [
        template,
    ]
})
export class Icon extends Vue {

    // ==================================
    // Getters
    // ==================================
    public get src() {

        // if (APP_THEME === 'daimler') {

        //     // return `${APP_ASSETS_URL}images/sprites/icons__daimler_${ICONVERSION_DAIMLER}.svg#${this.name}`
        //     return `/images/sprites/icons__daimler_${ICONVERSION_DAIMLER}.svg#${this.name}`
        // } else {

            if (this.file && this.file != 'mgs') {
                return `${APP_BASE_URL}assets/images/sprites/icons__${this.file}.svg#${this.name}`
            }

            return `${APP_ASSETS_URL}images/sprites/icons__mgs_${ICONVERSION_MERCEDES}.svg#${this.name}`
        // }
    }

    public get sizeClass() {
        return this.size ? `${this.$appPrefix}-icon--${this.size}` : ''
    }

    public get animationClass() {
        //default spin for Ajax-Loader-icon! wb-icon-428__buffer-loader--default
        if ( this.animation ) {
            return `${this.animation}`
        }
        if (this.name == this.$icons.AJAX_LOADER)
        {
            return `spin`
        }
        return ''
    }

    // ==================================
    // Component props
    // ==================================
    /**
     * Der name des Icons
     */
    @Prop([String])
    name!: string

    /**
     * Die Datei in den das Icon gesucht werden soll. Default ist 'mgs'.
     * Für anwendungsspezifische Icons 'app'.
     */
    @Prop({type: [String], default: 'mgs'})
    file?: string

    /**
     * Die Größe des Icons.
     *
     * Mögliche werte: xs, sm, md, lg, xl, big
     */
    @Prop({type: [String]})
    size?: string;

    /**
     * Wenn das Icon animiert werden soll, kann man hier die CSS Animationsklasse angeben.
     *
     * Wenn dieser Wert nicht gesetzt ist und das Icon AJAX_LOADER ist, wird immer die 'spin' Animation verwendet.
     */
    @Prop([String])
    animation?: string;

    public handleClick(e: any) {
        this.$emit('click', e)
    }
}